import { render, staticRenderFns } from "./PromoCodePage.vue?vue&type=template&id=65214379"
import script from "./PromoCodePage.vue?vue&type=script&lang=js"
export * from "./PromoCodePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65214379')) {
      api.createRecord('65214379', component.options)
    } else {
      api.reload('65214379', component.options)
    }
    module.hot.accept("./PromoCodePage.vue?vue&type=template&id=65214379", function () {
      api.rerender('65214379', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/promo-code-page/PromoCodePage.vue"
export default component.exports